import { Button, ButtonProps } from "@mui/material";
import React from "react";

export const SubmitButton = ({ children, ...props }: ButtonProps) => {
  return (
    <Button type="submit" variant="contained" {...props}>
      {children}
    </Button>
  );
};
